import CSHelpPanel from "@cloudscape-design/components-themed/help-panel";
import { useAppSelector } from "../../app/hook";

const HelpPanel = () => {
  return (
    <CSHelpPanel
      header={useAppSelector((state) => state.helpPanel.header)}
      footer={useAppSelector((state) => state.helpPanel.footer)}
    >
      {useAppSelector((state) => state.helpPanel.content)}
    </CSHelpPanel>
  );
};

export default HelpPanel;
